import React from 'react'
import { Grid } from '@material-ui/core'
import { useStyles } from './Styles'
import { FormattedMessage } from 'react-intl'
import { PageConsumer } from '../../../PageContext'
import PageTitle from '../PageTitle/PageTitle'
import { FormLoader } from '../../Loader/FormLoader'
import Alert from '@material-ui/lab/Alert'
import PageForm from './PageForm'
import { NamedRoutes } from '../../../routes'
import BreadCrumb from '../BreadCrumb'

const PageEditContent = ({ pageTitle, adminSectionType }) => {
  const classes = useStyles()
  return (
    <>
      <BreadCrumb links={[
        {
          key: 'BreadcrumbLink-1',
          name: <FormattedMessage id='Sidebar.Links.Pages'/>,
          link: NamedRoutes[adminSectionType].page.list
        }
      ]} current={pageTitle ?? <FormattedMessage id='Pages.List.AddPage.Title'/>}/>
      <PageTitle title={pageTitle ?? <FormattedMessage id='Pages.List.AddPage.Title'/>}/>
      <Grid container spacing={4}>
        <Grid item xs={12} className={classes.EditProfileContentContainer}>
          <div className={classes.EditProfileContent}>
            <PageConsumer>
              {({ pageDataLoading, pageDataFailure, pageData, handlePageSubmit, pageAction }) => (
                <>
                  {!!pageDataLoading && <FormLoader loading={true}/>}
                  {!!pageDataFailure &&
                  <Alert severity="error"><FormattedMessage id='UpdateProfile.FormErrorAlert'/></Alert>
                  }
                  {pageAction === 'add' ?
                    <PageForm adminSectionType={adminSectionType} currentDate={{}} onSubmit={handlePageSubmit}/> :
                    (!!pageData && !!Object.keys(pageData).length &&
                      <PageForm adminSectionType={adminSectionType} currentDate={pageData}
                                onSubmit={handlePageSubmit}/>)
                  }
                </>
              )}
            </PageConsumer>
          </div>
        </Grid>
      </Grid>
    </>
  )
}

export default PageEditContent
